import z from 'src/lib/zod'

export const SubtaskSchema = z.object({
    name: z.string(),
    completed: z.number(),
})

export type Subtask = z.infer<typeof SubtaskSchema>